import { render, staticRenderFns } from "./supplierList.vue?vue&type=template&id=44acc6b0&scoped=true"
import script from "./supplierList.vue?vue&type=script&lang=js"
export * from "./supplierList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44acc6b0",
  null
  
)

export default component.exports